import {
    can_mortgage_payment_purchase,
    can_mortgage_payment,
} from '@ratehub/mortgage-calculations';
import {
    SCENARIO_TYPES,
    getPaymentFrequencyAndDivisor,
} from '@ratehub/mtg-common';


// This is NOT a JSX component, and thus should not require prop-types, but ESLint is complaining we're missing prop-types...
/* eslint-disable react/prop-types */

function getPaymentCalculatorMonthlyPayment({ formValues, paymentScenario }) {
    const { scenarioType, askingPrice, mortgageAmount, scenarios } = formValues;

    if (!scenarioType || !scenarios) {
        return null;
    }

    const { frequency, divisor } = getPaymentFrequencyAndDivisor(scenarios[paymentScenario].paymentFrequency);

    const selectedRateValue = scenarios[paymentScenario].selectedRate?.value
        ? scenarios[paymentScenario].selectedRate.value / 100
        : null;

    return scenarioType === SCENARIO_TYPES.PURCHASE
        ? _getMonthlyPaymentPurchase({
            homePrice: askingPrice,
            downPaymentPercent: scenarios[paymentScenario].downPayment?.percent / 100,
            selectedRate: selectedRateValue,
            amortization: parseInt(scenarios[paymentScenario].amortization),
            frequency,
            divisor,
        })
        : _getMonthlyPaymentRenewal({
            homePrice: mortgageAmount,
            selectedRate: selectedRateValue,
            amortization: parseInt(scenarios[paymentScenario].amortization),
            frequency,
            divisor,
        });
}

function _getMonthlyPaymentPurchase({ homePrice, downPaymentPercent, selectedRate, amortization, frequency, divisor }) {
    if (!homePrice || downPaymentPercent == null || !selectedRate || !amortization) {
        return null;
    }

    return can_mortgage_payment_purchase(
        homePrice,
        downPaymentPercent,
        selectedRate,
        amortization,
        frequency,
        divisor,
    );
}

function _getMonthlyPaymentRenewal({ homePrice, selectedRate, amortization, frequency, divisor }) {
    if (!homePrice || !selectedRate || !amortization) {
        return null;
    }

    return can_mortgage_payment(
        homePrice,
        selectedRate,
        amortization,
        frequency,
        divisor,
    );
}

export default getPaymentCalculatorMonthlyPayment;
